<template>
  <div>
    <BaseModal
      :showing="visible"
      size="max-w-5xl"
      @close="$emit('close')"
      @opened="onOpened"
    >
      <BaseCard
        title="Daftar Login Pengguna"
        :description="`Tanggal ${datetime}`"
        :with-style="false"
      >
        <div class="space-y-4 border-t pt-5">
          <div class="flex items-center justify-end gap-2">
            <BaseSelect
              :options="officeTypeFilterOptions"
              :shadow="false"
              v-model="filter.officeType"
              @change="loadUserLogs"
            />
            <BaseInput
              type="search"
              :shadow="false"
              placeholder="Cari Email"
              debounce
              v-model="filter.search"
              @native-input="loadUserLogs"
            />
          </div>

          <Datatable
            :columns="tableColumns"
            :total="userLogs.meta.summary.total"
            :perPage="userLogs.meta.page.perPage"
            :currentPage="userLogs.meta.page.currentPage"
            :meta="userLogs.meta"
            cursor
            @pagechanged="onChangePage"
          >
            <template #tbody="{ classes }">
              <tr
                v-for="log in userLogs.data"
                :key="log.id"
                :class="classes.tr"
              >
                <td :class="classes.td">
                  {{ log.attributes.loginAt | formatDate('HH:mm') }}
                </td>
                <td :class="classes.td">
                  <p class="font-medium text-gray-900">
                    {{ log.attributes.name }}
                  </p>
                  <p>{{ log.attributes.email }}</p>
                </td>
              </tr>
            </template>
          </Datatable>
        </div>
      </BaseCard>
    </BaseModal>
    <Loading v-if="loading" />
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { requestMixin } from '../../../mixins/request/request';
import BaseModal from '../../base/BaseModal.vue';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export default {
  mixins: [requestMixin],
  props: {
    visible: Boolean,
    hour: String,
    date: String
  },
  emits: ['close'],
  components: {
    BaseModal,
  },
  data() {
    return {
      filter: {
        officeType: null,
        search: null,
      },
      loading: false,
      userLogs: {
        data: [],
        meta: {
          page: {},
          summary: {
            total: 0,
          },
        },
      },
    };
  },
  computed: {
    datetime() {
      if (!this.hour) {
        return null
      }
      return dayjs(this.date)
        .set('hour', +this.hour.slice(0, 2))
        .startOf('hour')
        .format('DD MMMM YYYY HH:mm');
    },
    officeTypeFilterOptions() {
      return [
        { key: null, label: 'Semua', value: null },
        { key: 'pusat', label: 'Pusat', value: 'pusat' },
        {
          key: 'kantor_pelayanan',
          label: 'Kantor Pelayanan',
          value: 'kantor_pelayanan',
        },
        {
          key: 'stockist_center',
          label: 'Stockist Center',
          value: 'stockist_center',
        },
        { key: 'stockist', label: 'Stockist', value: 'stockist' },
        { key: 'member', label: 'Mitra Usaha', value: 'member' },
      ];
    },
    tableColumns() {
      return [
        { id: 'login_at', name: 'Jam' },
        { id: 'user', name: 'Pengguna' },
      ];
    },
  },
  methods: {
    async loadUserLogs(params) {
      this.loading = true;

      const from = dayjs(this.date)
        .set('hour', +this.hour.slice(0, 2))
        .startOf('hour')
        .format('YYYY-MM-DD HH:mm:ss');
      const to = dayjs(this.date)
        .set('hour', +this.hour.slice(0, 2))
        .endOf('hour')
        .format('YYYY-MM-DD HH:mm:ss');

      const [res, err] = await this.request(`/api/v1/user-logs`, {
        params: {
          'fields[user-logs]': 'loginAt,name,email',
          sort: '-loginAt',
          'filter[office_type]': this.filter.officeType,
          'filter[search]': this.filter.search,
          'filter[from]': from,
          'filter[to]': to,
          'filter[global]': true,
          'page[limit]': 5,
          with_summary: true,
          ...params,
        },
      });

      if (!err) {
        this.userLogs = res;
      }

      this.loading = false;
    },
    onChangePage(page) {
      this.loadUserLogs(page);
    },
    onOpened() {
      this.filter.officeType = null;
      this.filter.search = null;

      this.loadUserLogs();
    },
  },
};
</script>
